import { MANAGEMENT_SIGNALS_API_INTEGRATION_STATUS_QUERY_KEY } from "./const";
import type { ManagementSignalsApiIntegrationQueryFactory } from "./types";

export const managementSignalsApiQueryKeys: ManagementSignalsApiIntegrationQueryFactory = {
    getStatus(): readonly string[] {
        return [MANAGEMENT_SIGNALS_API_INTEGRATION_STATUS_QUERY_KEY];
    },
};
